<div class="container">
  <div class="row align-items-center image-position">
    <!--    image-->
    <div class="col-12 col-md-5 order-md-2 image-position mb-md-5">
      <img src="assets/resources/IMG_0178_darker_1200_72.jpg" class="img-fluid my-photo" alt="photo">
      <img src="assets/resources/img_top.png" class="img-fluid sticker-top" alt="photo">
      <img src="assets/resources/img_bottom.png" class="img-fluid sticker-bottom" alt="photo">
    </div>

    <!--    hero text-->
    <div class="col-12 col-md-7 order-md-1 mt-5 leader-position">
      <h4 class="lead-header text-left" translate>WelcomeMessage1<br/>
        <span translate>WelcomeMessage2</span>
        <div class="d-inline">
          <span class="lead-header bg-black text-white" translate>JuniorJavaDev</span>
        </div>.
      </h4>

      <p class="lead-text text-left mt-4 mb-6 mb-lg-8" translate>
        WelcomeInfo
      </p>
      <div class="text-center text-md-left">
        <a href="#contact" class="btn bg-black lift mr-2 mr-md-3 lead-button" translate>ContactBtn</a>
        <a href="#work" class="btn btn-outline-dark lift ml-2 ml-md-3 lead-button" translate>CheckWorkBtn</a>
      </div>
    </div>
  </div>
</div>
